import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { motion } from 'framer-motion';

export const Nav = styled(motion.div)`
background: #33682c;
height: 100vh;
position: ${({ isMobile }) => (isMobile ? 'fixed' : 'sticky')}; 
z-index: 999; 
top: 0;
`;

export const NavTopSection = styled.div`
display: flex;
flex-direction: row;
align-items: center;
justify-content: space-between;
margin-bottom: 25px;
padding: 15px 20px;
`;

export const NavLogo = styled(motion.img)`
width: 100%;
max-width: 200px;
height: auto;

&:hover {
    cursor: pointer;
    transition: 0.2s all ease-in-out;
    transform: scale(1.05);
}
`;

export const NavBars = styled.div`
font-size: 30px;
color: #fff;
background: ${({ isMobile }) => (isMobile ? '#33682c' : 'transparent')};
border-radius: 10px;
padding: ${({ isMobile }) => (isMobile ? '5px 10px' : '0')};

&:hover {
    transition: all 0.2s ease-in-out;
    transform: scale(1.1);
    cursor: pointer;
}
`;

export const NavRoutes = styled.div`
display: flex;
flex-direction: column;
`;

export const RouteLink = styled(NavLink)`
display: flex;
flex-direction: row;
text-decoration: none;
gap: 10px;
padding: 15px 20px;
align-items: center;

&:hover {
    transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
    border-right: 4px solid #003d01;
    background: #619657;
}
`;

export const RouteName = styled(motion.p)`
font-size: 18px;
color: #fff;
white-space: nowrap;
`;

export const RouteIcon = styled.div`
display: flex;
font-size: 25px;
color: #fff;
vertical-align: bottom;
`;

export const NavDivider = styled.div`
width: 100%;
border-bottom: 1px solid rgba(255,255,255,0.2);
padding: 0 20px;
`;
